import {
  BrandPayload,
  BrandSubmitForm,
  Brands,
  UpdateBrandStatus,
} from "models/brand";
import axiosClient from "./axiosClient";
import { ApiResponse, ImageUrlData, RemovePayload } from "models";

const brandApi = {
  getBrandsList(data: BrandPayload): Promise<Brands> {
    return axiosClient.get(`/brand/getBrandDetail`, {
      params: {
        limit: data.limit,
        page: data.page,
        region: data.region,
        search: data.search,
        sortField: data.sortName,
        sortType: data.sortType,
        _t: Date.now(),
      },
      headers: {
        "Cache-Control": "no-cache",
      },
    });
  },
  getLocationsAndStoresByBrand(data: any): Promise<Brands> {
    return axiosClient.get(`/brand/getLocationsAndStoresByBrand`, {
      params: { brandId: data?.brandId }
    });
  },
  getBrandbyId(data: any): Promise<Brands> {
    return axiosClient.get(`/brand/getBrandById`, {
      params: { _id: data?.id, _t: Date.now() },
      headers: {
        "Cache-Control": "no-cache",
      },
    });
  },
  getAllMainBrand(): Promise<ApiResponse> {
    return axiosClient.get(`/brand/getAllMainBrand`);
  },

  getCustomersList(data: BrandPayload): Promise<Brands> {
    return axiosClient.get(`/customer/getAllCustomer`, {
      params: {
        disablePagination: data.disablePagination !== undefined && data.disablePagination !== null ? data.disablePagination : undefined
      }
    });
  },

  addBrand(data: BrandSubmitForm): Promise<ApiResponse> {
    return axiosClient.post(`/brand/createBrandAndStore`, data);
  },

  addOrUpdateMultiStoreKotConfig(data: any): Promise<ApiResponse> {
    return axiosClient.post(`/kot/addOrUpdateMultiStoreKotConfig`, data);
  },

  updateBrand(data: BrandSubmitForm): Promise<ApiResponse> {
    return axiosClient.put(`/brand/updateBrandDetail`, data, {
      params: { id: data._id }
    });
  },

  deleteBrand(data: RemovePayload): Promise<ApiResponse> {
    return axiosClient.delete(`/brand/removeBrand`, {
      params: { id: data._id }
    });
  },

  getImageUrl(data: ImageUrlData): Promise<ApiResponse> {
    return axiosClient.post(`/settings/uploadImage`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  changeBrandStatus(data: UpdateBrandStatus): Promise<ApiResponse> {
    return axiosClient.put(`/brand/approveBrand`, { isApproved: data.isApproved }, {
      params: { id: data.brandId }
    });
  },

  getBrandLocation(brandId: string): Promise<ApiResponse> {
    return axiosClient.get(`/location/getbrandLocation`, {
      params: { brandId }
    });
  },

  getKotConfigs(brandId: string): Promise<ApiResponse> {
    return axiosClient.get(`/kot/getKotConfigs`, {
      params: { brandId }
    });
  },
};

export default brandApi;
